
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { httpService } from '../components/body.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { PDFDocument, StandardFonts } from 'pdf-lib';

  


@Component({
  selector: 'app-entrega',
  templateUrl: './entrega.component.html',
  styleUrls: ['./entrega.component.css']
})
export class EntregaComponent implements OnInit {

  dibujando: boolean = false;
  pdfCargado: boolean = false;
  loading: boolean = false;
  firmado: boolean = false;
  enviado: boolean = false;
  pdf: any;
  pdffirmado: any;
  firmapdf: any;
  logopdf: any;
  albaran: any;
  fileFirmado: any;
  muestraFirmar: boolean = false;
  muestraLecturaQr: boolean = false;
  muestraCamara: boolean = false;
  muestraFirmaManuscrita = false;
  qr: any;
  comentario: String = '';


  elementType = 'url';  
  public imagePath;  
  value : any;  
  @ViewChild('result') resultElement: ElementRef;  
  
  
/*
  @ViewChild('scanner')
  scanner: ZXingScannerComponent;
*/

  @ViewChild('video') videoElement: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  //@ViewChild('canvas') mycanvas: HTMLCanvasElement;

  constraints = {
    video: {
        facingMode: "environment",
        width: { ideal: 300 },
        height: { ideal: 300 }
    }
  };
 
  videoWidth = 0;
  videoHeight = 0;
  stream: any;

  hasDevices: boolean;
  hasPermission: boolean;
  //qrResult: Result;
  scannerEnabled: boolean;

  currentDevice: MediaDeviceInfo = null;

  //elementType = 'url';
  //value: any;
  //@ViewChild('result') resultElement: ElementRef;

   stopCamara: boolean = false;
   showQRCode: boolean;
   
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
 
  private signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 1,
    'canvasWidth': 300,
    'canvasHeight': 300,
    'backgroundColor': 'rgb(240,240,240)',

  };
  
  signature: string;
 

  constructor( public http: httpService, private renderer: Renderer2, public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
   }

  ngOnInit() {
    this.abrirAlbaran();
  }

  async  createPdf() {
    
    const certificado = '/assets/pdf/certificacion.pdf';
    const pdftoBytescertificado = await fetch(certificado).then(res =>
      res.arrayBuffer()
    )


    const imagen = '/assets/pdf/logofirma2.png'
    const pdftoBytesimagen = await fetch(imagen).then(res =>
      res.arrayBuffer()
    )

    const paginas = await PDFDocument.load(this.pdf);
    const paginacertificado = await PDFDocument.load(pdftoBytescertificado);

    let numpages = paginas.getPageCount();
    let lastpage = numpages - 1;

    const pdfDoc = await PDFDocument.create();
    const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)

    let pages = [];

    for (let i = 0; i < numpages; i++) {
      pages.push(i);
    }

    // console.log(pages)

    let docPages = [];
    let certPages = [];

    docPages = await pdfDoc.copyPages(paginas, pages)
    certPages = await pdfDoc.copyPages(paginacertificado, [0]);

    const Image = await pdfDoc.embedPng(pdftoBytesimagen);
   
    for (let i = 0; i < numpages; i++) {
      pdfDoc.addPage(docPages[i])
    }

   const encriptado = this.http.encryptData(this.albaran._id + "-" + this.qr._id, 'Smart2020');

   for (let i = 0; i < numpages; i++) {
    docPages[i].drawText('Verificado por SmartBiometrik',
      { x: 10, y: 18, size: 6 });
    docPages[i].drawText('V_Id: ' + encriptado,
      { x: 10, y: 10, size: 6 }
    )
  }

    pdfDoc.addPage(certPages[0]); 
    let hojas = pdfDoc.getPages();
    let hojafirma = hojas[numpages];


    hojafirma.drawText('Verificado por SmartBiometrik', { x: 10, y: 18, size: 6 });
    hojafirma.drawText('V_Id: ' + encriptado, { x: 10, y: 10, size: 6 });
    // Establecemos tipo letra y tamaño
    hojafirma.setFont(helveticaFont);
    hojafirma.setFontSize(10);
    let y = hojafirma.getHeight() - 150; // coordenada Y va decreciendo
    // Insertamos datos del Evento en la plantilla sb[yyyy][idEmisor][mm][idEvento][dd
    // let ident = this.utils.fechaToString(1);
    hojafirma.drawText(this.albaran.descripcion, { x: 160, y: y - 82 });
    hojafirma.drawText(this.albaran._id + "-" + this.qr._id, { x: 160, y: y - 102 });
 
    hojafirma.drawText('EMISOR: ', { x: 70, y: y - 152 });
    hojafirma.drawText(this.albaran.emisor.nombre + '( ' + this.albaran.emisor.organizacion + ' )', { x: 140, y: y - 152 });
    //hojafirma.drawText('123456789-A', { x: 350, y: y - 152 });
   
    y = y - 172;
    hojafirma.drawText('RECEPTOR: ', { x: 70, y: y });
    let nombre = this.qr.emisor.nombre + ' ( ' + this.qr.emisor.organizacion + ' )'
    // nombre = nombre.substr(0, 32);
    hojafirma.drawText(nombre, { x: 140, y: y });
    // hojafirma.drawText('123456789A', { x: 350, y: y });
    //
    let x_text = 105;
    let logox = 100;
    let x_izquierda = 105;
    let x_derecha = 315;
    let logo_derecha = 270;
    let logo_izquierda = 60;
    y = y - 100;
    
    const fechafirma = this.fechaToString(1);
    const horafirma = this.fechaToString(2);

    let usuarioFirma = atob(this.signature);
    let imageFirma = await pdfDoc.embedPng(usuarioFirma);
        hojafirma.drawImage(imageFirma, { x: logo_derecha + 150, y: y, width: 150, height: 60 })
        hojafirma.drawText('Firma:', { x: logo_derecha + 150, y: y + 55, size: 8 })
        hojafirma.drawImage(Image, { x: logo_izquierda, y: y, width: 180, height: 70 })
        hojafirma.drawText('Autorizado: ' + this.qr.destinatario.nombre, { x: x_text, y: y + 20, size: 8 })
     //   hojafirma.drawText('Autorizado de: ' + , { x: x_text, y: y + 10, size: 8 })
        hojafirma.drawText('Fecha: ' + fechafirma + ' a las ' + horafirma + ' horas', { x: x_text, y: y + 10, size: 8 })


    const pdfBytes = await pdfDoc.save();
    let mypdf = new Blob([pdfBytes], { type: 'application/pdf' })
    let blobUrl = URL.createObjectURL(mypdf);
    
     this.fileFirmado = this.blobToFile(mypdf, this.albaran.nombre);
  
      this.pdf = blobUrl;
      //this.pdfCargado = true;
      this.loading = false;
      this.firmado = true;
      this.enviarpdf();

  }

  blobToFile = (theBlob: Blob, fileName: string): File => {
    let b: any = theBlob;
    //Blob() es también File() - Añadimos los dos parámetros necesarios para un archivo tipo File
    b.lastModifiedDate = new Date();
    b.name = fileName;
  
    //Casteamos al tipo File()
    return <File>theBlob;
  }

  mrender(e) {  
    //let element: Element = this.renderer.createElement('h1');  
    //element.innerHTML = e.result; 
    console.log(e.result);
    let res = e.result.toString();
    console.log(res);
    if (res.indexOf('Couldn') === -1) {
      this.stopvideo();
      this.handleQrCodeResult(res);
    }
    //this.renderElement(element);  
  }  
  
  renderElement(element) {  
    for (let node of this.resultElement.nativeElement.childNodes) {  
      this.renderer.removeChild(this.resultElement.nativeElement, node);  
    }  
    this.renderer.appendChild(this.resultElement.nativeElement, element);  
  }  

 
  cerrar() {
    this.muestraCamara = false;
    this.pdfCargado = true;
    this.stopvideo();
  }

  firmar() {
    this.pdfCargado = false;
    this.muestraCamara = true;
    this.startCamera();
  }

  firmarQr() {
    this.toastr.success('Jajaja, os puede la ansiedad, eh??','Ansioso')
  }

  startCamera() {
    this.loading = true;
    if (!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) { 
        navigator.mediaDevices.getUserMedia(this.constraints).then(this.attachVideo.bind(this)).catch(this.handleError);
    } else {
        alert('Sorry, camera not available.');
    }
  }

  handleError(error) {
  console.log('Error: ', error);
  // this.loading = false;
  }


attachVideo(stream) {
  
  this.muestraCamara = true;
  this.stream = stream;
  this.renderer.setProperty(this.videoElement.nativeElement, 'srcObject', stream);
  this.renderer.listen(this.videoElement.nativeElement, 'play', (event) => {
      this.videoHeight = this.videoElement.nativeElement.videoHeight;
      this.videoWidth = this.videoElement.nativeElement.videoWidth;
  });


 this.startTimer();
 this.loading = false;
 
}

timeLeft: number = 1;
  interval;

startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 1;
        this.capture();
      }
    },1000)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  async capture() {
      //this.renderer.setProperty(this.canvas.nativeElement, 'width', this.videoWidth);
      //this.renderer.setProperty(this.canvas.nativeElement, 'height', this.videoHeight);
      //this.canvas.nativeElement.getContext('2d').drawImage(this.videoElement.nativeElement, 0, 0);
      let canvas = document.createElement("canvas");
      canvas.height = 300;
      canvas.width = 300;
      canvas.getContext('2d').drawImage(this.videoElement.nativeElement, 0, 0);
      //this.renderElement(canvas);
      this.value = canvas.toDataURL('image/png', 1);
      //console.log(this.value);
  
}

stopvideo() {
  this.pauseTimer();
  this.stream.getTracks().forEach(function(track) {
    track.stop();
  });

  this.muestraCamara = false;
  this.muestraFirmar = true;
}

decode() {
 
}



  scanCompleteHandler(e) {
  }

  handleQrCodeResult(e) {
    this.loading =  true;
      this.http.getQr(e).subscribe( qr => {

        if (qr.status === 'ok') {
          console.log(qr);
          this.loading = false;
          if (qr.message) {
            this.toastr.success('Sello Digital Reconocido', 'Firma Albarán Digital')
            this.qr = qr.message;
            this.loading = false;
            this.muestraFirmar = false;
            this.muestraLecturaQr = true;
          } else {
            this.toastr.error('Ese Sello Digital no pertenece a ningún Cliente', 'Firma Albarán Digital')
            this.loading = false;
          }
          
        }

      })
   
  }

  firmarManuscrita() {
    this.muestraLecturaQr = false;
    this.muestraFirmaManuscrita = true;
  }



 abrirAlbaran() {
    this.loading = true;
    this.pdfCargado = false; 
    
    this.http.getAlbaran(this.http.albaranFirma).subscribe( async resp => {
      console.log(resp)
      if (resp.message && resp.status !== 'bad') {
          this.albaran = resp.message;
            if (this.albaran.estado !== 'Firmado' && this.albaran.estado !== 'Borrado') {
              this.pdf = await fetch(resp.message.link).then(res =>
                res.arrayBuffer()
              )
              //this.createPdf();
              
              this.pdfCargado = true;
              this.loading = false;
            }

            if (this.albaran.estado === 'Firmado') {
              this.loading = false;
              this.http.showAlerta('El Albarán que intenta abrir, ya está Firmado.', 'Carga de Albarán', 'warning')
            }

            if (this.albaran.estado === 'Borrado') {
              this.loading = false;
              this.http.showAlerta('El Albarán que intenta abrir, ha sido borrado por el Emisor.', 'Carga de Albarán', 'warning')
            }

      } else {
        this.loading = false;
        this.http.showAlerta('El Albarán que intenta abrir, no se encuentra disponible.', 'Carga de Albarán', 'warning')
      }
    }, err => {
      this.http.showAlerta('Oops, ha ocurrido algo inesperado al cargar el Albarán', 'Cargar Albarán', 'error')
      this.loading = false;
    })
    
   
  }

 
 
  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    console.log(this.signaturePad.toDataURL());
    this.signature = btoa(this.signaturePad.toDataURL());
  }
 
  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
    console.log('begin drawing');
    this.dibujando = true;
  }

  borrarPad() {
    this.signaturePad.clear();
    this.dibujando = false;
  }

  cancelarPad() {
    this.muestraFirmaManuscrita = false;
    this.pdfCargado = true;
    this.value = '';
  }

  cancelarCamara() {
    this.muestraCamara = false;
    this.stopvideo();
    this.pauseTimer();
    this.pdfCargado = true;
    this.value = '';
  }

  cancelarDatos() {
    this.muestraLecturaQr = false;
    this.pdfCargado = true;
    this.value = '';
  }

  finalizarFirma() {
    if (this.dibujando) {
      this.muestraFirmaManuscrita = false;
      this.createPdf();
      //this.pdfCargado = true;
      this.value = '';
    } else {
      this.http.showAlerta('Debe dibujar su firma manuscrita', 'Albaran Digital', 'warning') }
  }

  fechaToString(tipo, fecha?){
    let dias = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    let today: Date;
    if (fecha) {
      today = new Date(fecha);
    } else {
      today = new Date(Date.now());
    }

    let dd = today.getDate().toString();
    let mm = (today.getMonth() + 1).toString();
    let hh = today.getHours().toString();
    let nn = today.getMinutes().toString();
    let ss = today.getSeconds().toString();
    let yyyy: String;

    if (Number(hh) < 10) hh = '0' + hh;
    if (Number(nn) < 10) nn = '0' + nn;

    if (Number(mm) < 10) mm = '0' + mm;
    if (Number(dd) < 10) dd = '0' + dd;

    yyyy = today.getFullYear().toString();

    let result = '';

    if (tipo === 0) result = yyyy + '-' + mm + '-' + dd; // Fecha formato ingles
    if (tipo === 1) result = dd + '-' + mm + '-' + yyyy; // Fecha formato español
    if (tipo === 2) result = hh + ':' + nn; // hora formato HH:MM
    if (tipo === 3) result = yyyy + mm + dd + hh + nn + ss; // numero resumen
    if (tipo === 4) result = yyyy + '-' + mm + '-01';
    if (tipo === 5) result = yyyy + '-' + mm + '-' + dias[Number(mm) - 1];
    if (tipo === 6) result = dd + '-' + mm + '-' + yyyy + '  ' + hh + ':' + nn + ' horas.'; // Fecha formato español fecha + hora
    if (tipo === 7) result = dd + '-' + mm + '-' + yyyy + ' a las ' + hh + ':' + nn + ' horas.'; // Fecha formato español fecha + hora

    return result;
  }

  enviarpdf() {
    this.loading = true;
    console.log('EnviarPDF');
    let error = false;
    this.http.subirfichero(this.fileFirmado, this.albaran.emisor._id, this.albaran._id, this.albaran.descripcion + '_firmado.pdf').subscribe( async firmado => {
      console.log(firmado);
      if (firmado.status === 'ok') {

        let bodyEntrega = {
          qr: this.qr._id,
          autorizado: {
            nombre: this.albaran.destinatario.nombre.toUpperCase(),
            email: this.albaran.destinatario.email.toLowerCase()
          },
          link: firmado.url,
          fecha: new Date()
        }

        this.albaran.entrega = bodyEntrega;
        this.albaran.estado = 'Firmado';
        console.log(this.albaran);

        this.http.updateAlbaran(this.albaran).subscribe( async entrega => {
          console.log(firmado);
          if (entrega.status === 'ok') {
            
                let mensaje =`
                  <p><strong>FIRMA ALBARAN DIGITAL</strong></p>
                  <p>Buenas, <strong>`+ this.albaran.emisor.nombre + ` ( `+ this.albaran.emisor.organizacion + ` )</strong></p>
                  <p>Su ALBARAN DIGITAL  <strong>` + this.albaran.descripcion + `</strong> ha sido firmado por <strong>` + this.qr.emisor.nombre + ` ( ` + this.qr.emisor.organizacion + ` )</strong> </p>
                  <p>Puede acceder al mismo en su DashBoard Albarán Digital Smartbiometrik</p>
                  <a href="https://albarandigital.smartbiometrik.com">DashBoard Albaran Digital SmartBiometrik</a><br>`; 
                  
                  this.http.sendGenericMailWithAttachment('Firma Albarán Digial', mensaje, this.albaran.emisor.email, firmado.url,  this.albaran.descripcion + '_firmado.pdf').subscribe( resp => {
                    console.log(resp);
                    if (resp.status === 'ok') {
                      //this.toastr.success('Se ha enviado la firma con éxito al Emisor del Albarán', 'Firma Completada')
                    } else {
                      error = true;
                      //this.toastr.error('Oops, algo ha salido mal al enviar el correo.', 'Envio Email')
                    }
                  })

                  mensaje =`
                  <p><strong>FIRMA ALBARAN DIGITAL</strong></p>
                  <p>Buenas, <strong>`+ this.qr.emisor.nombre + ` ( ` + this.qr.emisor.organizacion + ` )</strong></p>
                  <p>El ALBARAN DIGITAL  <strong>` + this.albaran.descripcion + `</strong> emitido por <strong>` +  this.albaran.emisor.nombre  + ` ( ` + this.albaran.emisor.organizacion + ` )</strong>, ha sido firmado por su Autorizado <strong>` + this.qr.destinatario.nombre + `</strong></p>
                  <p>Puede acceder al mismo en su DashBoard Albarán Digital Smartbiometrik</p>
                  <a href="https://certificados.smartbiometrik.com">DashBoard Albaran Digital</a><br>`; 
                

                  this.http.sendGenericMailWithAttachment('Firma Albarán Digial', mensaje, this.qr.emisor.email, firmado.url,  this.albaran.descripcion + '_firmado.pdf').subscribe( resp => {
                    console.log(resp);
                    if (resp.status === 'ok') {
                      //this.toastr.success('Se ha enviado la firma con éxito al Receptor del Albarán', 'Firma Completada')
                      this.loading = false;
                      if (error === false) {
                        this.enviado = true
                        this.http.showAlerta('Se ha firmado el Albarán con éxito y se ha enviado por correo copia del documento al Emisor y Receptor del Albarán', 'Firma Albarán', 'success')
                        this.pdfCargado = true;
                      } else {
                        this.enviado = false;
                        this.http.showAlerta('Algo salio mal el firmar y enviar el Albaran', 'Firma Albarán', 'error')
                      }
                    } else {
                      this.http.showAlerta('Algo salio mal el firmar y enviar el Albaran', 'Firma Albarán', 'error')
                      this.loading = false;
                      error = true;
                    }
                  })
              }  else {
                this.http.showAlerta('Oops, algo ha salido mal al firmar la Entrega', 'Entrega Albarán', 'error')
              }
            })
       
     
      } else {
        this.http.showAlerta('Oops, algo ha salido mal al subir Albarán firmado.', 'Entrega Albarán', 'error')
      }
    })

      
  }

}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/Angular/Urbanos/src/app/entrega/entrega.component.ts